const getters = {
    'token': state => state.user.token,
    'country': state => state.app.country,
    'sidebar': state => state.app.sidebar,
    'avatar': state => state.avatar
};

export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js